import './index'
import axios from 'axios'
import { Toast } from 'mint-ui'

const commonFunc = function (url, day, isClock, shareState) {
    let u = navigator.userAgent;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    let isGeneral = true;
    if (day == 1 || day == 3 || day == 7 || day == 14 || day == 21) {
        isGeneral = false
    }
    if (isiOS) {
        window.JXBJSBridge.call({
            target: "WKFunction",
            action: "shareChat",
            data: { url: url, day: day, isGeneral: isGeneral, isClock: isClock, shareState },
            callback: {
            }
        });
        // window.webkit.messageHandlers.shareChat.postMessage({url:url,day:day,isGeneral:isGeneral,isClock:isClock,shareState});
    } else {
        let obj = JSON.stringify({ url: url, day: day, isGeneral: isGeneral, isClock: isClock, shareState })
        if (window.Android && window.Android.shareChat) {
            window.Android.shareChat(obj);
        } else if (window.shareChat) {
            window.shareChat.jsMethod(obj);
        }
    }
}

export default {
    getDoCard: function (data, callback) {
        return axios.post('/activity/doCard/home', data).then(res => {  // 获取首页公共数据
            if (res) {
                callback(res)
            }
        }).catch(err => {
            Toast(err.msg)
        })
    },
    getDoCardMyData: function (data, callback) {
        return axios.post('/activity/doCard/myData', data).then(res => {  //获取首页我的数据
            if (res) {
                let obj = JSON.parse(JSON.stringify(res));
                if (res.medalWall.length > 5) {
                    obj.medalWall = res.medalWall.slice(0, 5);
                }
                callback(obj)
            }
        }).catch(err => {
            Toast(err.msg)
        })
    },
    patchCard: function (data, callback) {
        return axios.post('/activity/doCard/patchCard', data).then(res => {  // 补卡
            if (res) {
                if (res.poster && res.poster != '') {
                    // Toast("成功补卡一天");
                    commonFunc(res.poster, res.clockingTimes, true, false)
                    callback(res);
                } else {
                    // Toast("成功补卡一天");
                    callback(res);
                }
            }
        }).catch(err => {
            Toast(err.msg)
        })
    },
    clicking: function (data, callback) {
        return axios.post('/activity/doCard/clocking', data).then(res => {  // 打卡
            if (res) {
                if (res.poster && res.poster != '') {
                    commonFunc(res.poster, res.clockingTimes, true, false);
                    // if(res.)
                    // console.log(window.shareResult)
                    callback(res);
                } else {
                    // Toast("打卡成功");
                    callback(res);
                }
            }
        }).catch(err => {
            Toast(err.msg)
        })
    },
    getSharePoster: function (data, callback) {
        return axios.post('/activity/doCard/getSharePoster', data).then(res => {  // 获取分享图
            if (res) {
                let shareState = !!data.shareState
                commonFunc(res.poster, data.day, false, shareState)
                console.log(data)
                callback(res);
            }
        }).catch(err => {
            if (err.msg) {
                Toast(err.msg)
            } else {
                Toast("请求失败")
            }
        })
    },
    importImg: function (data, callback) {
        return axios.post('/file/upload', data).then(res => {  // 上传图片
            if (res) {
                callback(res)
            }
        }).catch(err => {
            Toast(err.msg)
        })
    },
    receivePrize: function (data, callback) {
        return axios.post('/activity/doCard/getAward', data).then(res => {  // 领取奖品
            if (res) {
                Toast("领取成功");
                callback(res)
            }
        }).catch(err => {
            Toast(err.msg)
        })
    },
    getAwardTips: function (data, callback) {
        return axios.post('/activity/doCard/getAwardTips', data).then(res => {  // 获取其他资料奖品提示语
            if (res) {
                callback(res)
            }
        }).catch(err => {
            Toast(err.msg)
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/activity.js